import { Card, CardContent, CardHeader } from "../../../../components/ui/common/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../../../components/ui/common/table";

interface Ingredient {
  _id: string;
  ingredient_name?: string;
}

interface IngredientDetail {
  ingredient_id: string;
  unit_size?: string;
  unit_type?: string;
  ean_bar_code?: string;
}

interface SupplierIngredientTableProps {
  ingredients: Ingredient[];
  ingredientDetails: IngredientDetail[];
}

const EYEBROW_CLASS =
  "tw-text-[10px] tw-uppercase tw-tracking-wider tw-text-muted-foreground tw-font-medium";

/**
 * Tailwind rebuild of the legacy `SupplierIngredientList`
 * (src/screens/supplier/supplierDetails/SupplierIngredientList.tsx), styled
 * to match the new Supplier grid (`SupplierTable`) rather than the old
 * green-header Semantic UI table — same "Ingredient Name / Unit Size / Unit
 * Type / EAN Number" columns and data mapping, just restyled. Only rendered
 * in the new View drawer; the legacy component is untouched.
 */
const SupplierIngredientTable = ({ ingredients, ingredientDetails }: SupplierIngredientTableProps) => {
  return (
    <Card className="tw-gap-4 tw-p-5">
      <CardHeader className="tw-p-0">
        <span className={EYEBROW_CLASS}>Ingredients</span>
      </CardHeader>
      <CardContent className="tw-p-0">
        <div className="tw-overflow-hidden tw-rounded-lg tw-border tw-border-border">
          <Table className="tw-w-full [&_td]:tw-px-4 [&_td]:tw-py-3 [&_th]:tw-px-4 [&_th]:tw-py-3">
            <TableHeader>
              <TableRow className="tw-border-b-0 tw-bg-primary/5 hover:tw-bg-primary/5 [&_th]:tw-bg-primary/5 [&_th]:tw-text-primary [&_th]:tw-font-semibold">
                <TableHead>Ingredient Name</TableHead>
                <TableHead>Unit Size</TableHead>
                <TableHead>Unit Type</TableHead>
                <TableHead>EAN Number</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {ingredients.map(ingredient => {
                const detail = ingredientDetails.find(d => d.ingredient_id === ingredient._id);
                return (
                  <TableRow key={ingredient._id} className="tw-bg-white hover:tw-bg-muted/50">
                    <TableCell className="tw-text-sm tw-text-foreground">
                      {ingredient.ingredient_name || "—"}
                    </TableCell>
                    <TableCell className="tw-text-sm tw-text-foreground">
                      {detail?.unit_size || "—"}
                    </TableCell>
                    <TableCell className="tw-text-sm tw-text-foreground">
                      {detail?.unit_type || "—"}
                    </TableCell>
                    <TableCell className="tw-font-mono tw-text-sm tw-text-foreground">
                      {detail?.ean_bar_code || "—"}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </div>
      </CardContent>
    </Card>
  );
};

export default SupplierIngredientTable;
